// extracted by mini-css-extract-plugin
export default {"unitsBlock":"units-roster_unitsBlock__Dv+pi","unitsBlockItem":"units-roster_unitsBlockItem__96iiA"};